import { useState, useEffect } from 'react'
import { DEBOUNCE_MS } from '@/constants/timing'

/**
 * Hook that debounces a value by the specified delay.
 * Useful for search inputs to avoid excessive API calls.
 *
 * @param value - The value to debounce
 * @param delay - Delay in milliseconds (default: DEBOUNCE_MS)
 * @returns The debounced value
 */
export function useDebouncedValue<T>(value: T, delay = DEBOUNCE_MS): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
